import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class ApiSalesService {

  // Category
  private openPurchase = new BehaviorSubject<boolean>(false);
  public openedPurchase = this.openPurchase.asObservable();

  // Cambiar API
  constructor(private http: HttpClient) { }

  setOpenPurchase(openPurchase: boolean) {
    this.openPurchase.next(openPurchase);
  }

  getOpenPurchase() { return this.openPurchase.getValue(); }

  getAllMethods() {
    const url = `${AppSettings.API_URI_V2}/order/sales-channels`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  getStatusByBusiness() {
    const url = `${AppSettings.API_URI_V2}/order/statuses`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  getMaxPriceByCompany(idCompany: number) {
    const url = `${AppSettings.API_URI_V2}/company/${idCompany}/orders/max-price`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  getStatusTransactionWeb(id_order: string) {
    const url = `${AppSettings.API_URI_V2}/orders/${id_order}/status`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }
}
